import logWebHeaderUpgradeToProTapped from '@alltrails/analytics/events/logWebHeaderUpgradeToProTapped';
import useUser from 'hooks/useUser';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import WebHeaderUpgradeToProCopyText from '@alltrails/analytics/enums/WebHeaderUpgradeToProCopyText';
import Link from '@alltrails/shared/denali/components/Link';
import CarouselDisplayTrigger from '@alltrails/analytics/enums/CarouselDisplayTrigger';
import useExperiment from 'hooks/useExperiment';
import useToggle from '@alltrails/shared/hooks/useToggle';
import { Suspense, lazy } from 'react';
import { NoSsr } from '@material-ui/core';
import * as styles from './MobileHomeLink.module.scss';

const CheckoutModal = lazy(() => import('components/CheckoutModal'));
const SignupModal = lazy(() => import('components/SignupModal'));

export default function MobileHomeLink() {
  const user = useUser();
  const [isSignupModalOpen, toggleSignupModal] = useToggle();
  const [isCheckoutModalOpen, toggleCheckoutModal] = useToggle();
  const experiment = useExperiment('growth-v2-on-page-web-checkout');

  return (
    <>
      <NoSsr>
        <Suspense fallback={null}>
          <CheckoutModal isOpen={isCheckoutModalOpen} onRequestClose={toggleCheckoutModal} trigger={CarouselDisplayTrigger.GlobalNavMenu} />
          <SignupModal
            heading={<FormattedMessage defaultMessage="Do more outdoors{br}with AllTrails+" values={{ br: <br /> }} />}
            trigger={CarouselDisplayTrigger.GlobalNavMenu}
            isOpen={isSignupModalOpen}
            onRequestClose={() => {
              toggleSignupModal();
            }}
            onSuccess={() => {
              toggleSignupModal();
              toggleCheckoutModal();
            }}
          />
        </Suspense>
      </NoSsr>
      {!user && (
        <Link
          className={styles.link}
          size="sm"
          testId="headerSignUp"
          {...(experiment?.value === 'treatment'
            ? {
                onClick: toggleSignupModal
              }
            : { href: '/plus' })}
        >
          <FormattedMessage defaultMessage="Try AllTrails+" />
        </Link>
      )}
      {user && !user.pro && (
        <Link
          className={styles.link}
          size="sm"
          {...(experiment?.value !== 'treatment' ? { href: '/plus' } : {})}
          testId="get-plus-mobile-home-link"
          onClick={() => {
            logWebHeaderUpgradeToProTapped({
              copy_text: user.isPromoEligible ? WebHeaderUpgradeToProCopyText.TryProFree : WebHeaderUpgradeToProCopyText.UpgradeToPro
            });

            if (experiment?.value === 'treatment') {
              toggleCheckoutModal();
            }
          }}
        >
          {user.isPromoEligible ? <FormattedMessage defaultMessage="Try AllTrails+" /> : <FormattedMessage defaultMessage="Get AllTrails+" />}
        </Link>
      )}
    </>
  );
}
